import { html } from "htm/preact";
import { Calendar } from "./calendar";
import { AddPatient, FileDetails, PatientDetails, PatientsOverview, UnpaidPatientsOverview, UpdatePatient } from "./patients";
import { useContext, useEffect, useState } from "preact/hooks";
import * as store from './store';
import { ToastContainer } from "react-toastify";
import Router, { route } from "preact-router";
import { Link } from 'preact-router/match';
import { Kanban } from "./kanban";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as bootstrap from "bootstrap";
import { searchPatients, useSession } from "./store";
import { Stats } from "./stats";
import { AddPrescription, DrugsOverview, DrugView, PrescriptionView } from "./drugs";
import fetch from "node-fetch";
import { AddPurchaseOrder, PurchaseOrderDetails, PurchaseOrdersOverview } from "./purchase-order";

function showInstallInstructions() {
    var m = new bootstrap.Modal(document.getElementById('install-info') as any)
    m.show();
}

function closeInstallInstructions() {
    var m = new bootstrap.Modal(document.getElementById('install-info') as any)
    m.hide();
}



export function Nav1({showNavbar,setShowNavbar}:any) {

    const [state] = useSession();

    const [shown, setShown] = useState({} as any);

    const setOpen = (name:string) => setShown({...shown, [name]:!shown[name]})
    
    return html`<nav class="navbar navbar-light navbar-vertical navbar-expand-xl">
    <div style="opacity:0" class="d-flex align-items-center">
        <div class="toggle-icon-wrapper">
            <button class="btn navbar-toggler-humburger-icon navbar-vertical-toggle" data-toggle="tooltip"
                data-placement="left" title="Toggle Navigation"><span class="navbar-toggle-icon"><span
                        class="toggle-line"></span></span></button>

        </div>
        <a class="navbar-brand" href="/">
            <div class="d-flex align-items-center py-3"><span class="font-sans-serif">NEO</span>
            </div>
        </a>
    </div>
    <div class="collapse navbar-collapse ${showNavbar ? 'show' : ''}" id="navbarVerticalCollapse">
        <div class="navbar-vertical-content scrollbar">
            <ul class="navbar-nav flex-column">
                <li class="nav-item">
                    <${Link}  onclick=${()=>setShowNavbar(false)} activeClassName="active" class="nav-link" href="/patients">
                        <div class="d-flex align-items-center">
                            <span class="nav-link-icon">
                                <span class="fas fa-user-injured"></span>
                            </span>
                            <span class="nav-link-text">Patients</span>
                        </div>
                    </${Link}>
                </li>
                <li class="nav-item">
                    <${Link}  onclick=${()=>setShowNavbar(false)} activeClassName="active" class="nav-link" href="/calendar">
                        <div class="d-flex align-items-center">
                            <span class="nav-link-icon">
                                <span class="fas fa-calendar-alt"></span>
                            </span>
                            <span class="nav-link-text">Calendrier</span>
                        </div>
                    </${Link}>
                </li>
                <li class="nav-item">
                    <${Link}  onclick=${()=>setShowNavbar(false)} activeClassName="active" class="nav-link" href="/waiting">
                        <div class="d-flex align-items-center">
                            <span class="nav-link-icon">
                                <span class="fab fa-trello"></span>
                            </span>
                            <span class="nav-link-text">Salle d'attente</span>
                        </div>
                    </${Link}>
                </li>
                <li class="nav-item">
                    <${Link} path="/stats/:child"  onclick=${()=>{setShowNavbar(false); setOpen('stats')}} activeClassName="active" class="nav-link dropdown-indicator ${shown['stats'] ? '' : 'collapsed' }  " href="/stats/revenue">
                        <div class="d-flex align-items-center">
                            <span class="nav-link-icon">
                                <span class="fas fa-user-injured"></span>
                            </span>
                            <span class="nav-link-text">Statistiques</span>
                        </div>
                    </${Link}>
                    <ul class="nav collapse ${shown['stats'] ? 'show' : ''}">
                        <li class="nav-item"><${Link} class="nav-link" activeClassName="active" href="/stats/revenue">Revenu</${Link}>
                        </li>
                        <li class="nav-item"><${Link} class="nav-link" activeClassName="active" href="/stats/patients-unpaid">Non payées</${Link}>
                        </li>
                    </ul>
                </li>
                <li class="nav-item">
                    <${Link}  onclick=${()=>setShowNavbar(false)} activeClassName="active" class="nav-link" href="/drugs">
                        <div class="d-flex align-items-center">
                            <span class="nav-link-icon">
                                <span class="fas fa-user-injured"></span>
                            </span>
                            <span class="nav-link-text">Médicaments</span>
                        </div>
                    </${Link}>
                </li>
                ${state.organization?.inventory ?
                html`<li class="nav-item">
                    <${Link} path="/inventory/:child"  onclick=${()=>{setShowNavbar(false); setOpen('inventory')}} activeClassName="active" class="nav-link dropdown-indicator ${shown['inventory'] ? '' : 'collapsed' }  " href="/inventory/purchase-orders">
                        <div class="d-flex align-items-center">
                            <span class="nav-link-icon">
                                <span class="fas fa-user-injured"></span>
                            </span>
                            <span class="nav-link-text">Inventaire</span>
                        </div>
                    </${Link}>
                    <ul class="nav collapse ${shown['inventory'] ? 'show' : ''}">
                        <li class="nav-item"><${Link} class="nav-link" activeClassName="active" href="/inventory/purchase-orders">Bons de commande</${Link}>
                        </li>
                        <li class="nav-item"><${Link} class="nav-link" activeClassName="active" href="/inventory/patients-unpaid">Non payées</${Link}>
                        </li>
                    </ul>
                </li>` : ''
                }
                <!--
                <li class="nav-item"><a class="nav-link dropdown-indicator" href="#pages" data-toggle="collapse"
                        role="button" aria-expanded="false" aria-controls="pages">
                        <div class="d-flex align-items-center"><span class="nav-link-icon"><span
                                    class="fas fa-copy"></span></span><span class="nav-link-text"> Pages</span>
                        </div>
                    </a>
                    <ul class="nav collapse" id="pages" data-parent="#navbarVerticalCollapse">
                        <li class="nav-item"><a class="nav-link" href="pages/activity.html">Activity</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="pages/associations.html">Associations</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="pages/billing.html">Billing</a>
                        </li>
                        <li class="nav-item"><a class="nav-link dropdown-indicator" href="#pages-errors"
                                data-toggle="collapse" role="button" aria-expanded="false"
                                aria-controls="pages-errors">Errors</a>
                            <ul class="nav collapse" id="pages-errors" data-parent="#pages">
                                <li class="nav-item"><a class="nav-link" href="pages/errors/404.html">404</a>
                                </li>
                                <li class="nav-item"><a class="nav-link" href="pages/errors/500.html">500</a>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="pages/event-create.html">Event create</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="pages/event-detail.html">Event detail</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="pages/events.html">Events</a>
                        </li>
                        <li class="nav-item"><a class="nav-link dropdown-indicator" href="#pages-faq"
                                data-toggle="collapse" role="button" aria-expanded="false" aria-controls="pages-faq">
                                <div class="d-flex align-items-center">Faq<span
                                        class="badge rounded-pill ml-2 badge-soft-success">New</span>
                                </div>
                            </a>
                            <ul class="nav collapse" id="pages-faq" data-parent="#pages">
                                <li class="nav-item"><a class="nav-link" href="pages/faq/faq-basic.html">Faq basic</a>
                                </li>
                                <li class="nav-item"><a class="nav-link" href="pages/faq/faq-alt.html">Faq alt</a>
                                </li>
                                <li class="nav-item"><a class="nav-link" href="pages/faq/faq-accordion.html">Faq
                                        accordion</a>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="pages/invite-people.html">Invite people</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="pages/invoice.html">Invoice</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="pages/notifications.html">Notifications</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="pages/people.html">People</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="pages/pricing.html">Pricing</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="pages/pricing-alt.html">Pricing alt</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="pages/privacy-policy.html">
                                <div class="d-flex align-items-center">Privacy policy<span
                                        class="badge rounded-pill ml-2 badge-soft-success">New</span>
                                </div>
                            </a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="pages/profile.html">Profile</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="pages/settings.html">Settings</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="pages/starter.html">Starter</a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item"><a class="nav-link" href="chat.html">
                        <div class="d-flex align-items-center"><span class="nav-link-icon"><span
                                    class="fas fa-comments"></span></span><span class="nav-link-text"> Chat</span>
                        </div>
                    </a>
                </li>
                <li class="nav-item"><a class="nav-link" href="kanban.html">
                        <div class="d-flex align-items-center"><span class="nav-link-icon"><span
                                    class="fab fa-trello"></span></span><span class="nav-link-text"> Kanban</span>
                        </div>
                    </a>
                </li>
                <li class="nav-item"><a class="nav-link" href="calendar.html">
                        <div class="d-flex align-items-center"><span class="nav-link-icon"><span
                                    class="fas fa-calendar-alt"></span></span><span class="nav-link-text">
                                Calendar</span>
                        </div>
                    </a>
                </li>
                <li class="nav-item"><a class="nav-link dropdown-indicator" href="#email" data-toggle="collapse"
                        role="button" aria-expanded="false" aria-controls="email">
                        <div class="d-flex align-items-center"><span class="nav-link-icon"><span
                                    class="fas fa-envelope-open"></span></span><span class="nav-link-text"> Email</span>
                        </div>
                    </a>
                    <ul class="nav collapse" id="email" data-parent="#navbarVerticalCollapse">
                        <li class="nav-item"><a class="nav-link" href="email/inbox.html">Inbox</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="email/email-detail.html">Email detail</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="email/compose.html">Compose</a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item"><a class="nav-link dropdown-indicator" href="#authentication"
                        data-toggle="collapse" role="button" aria-expanded="false" aria-controls="authentication">
                        <div class="d-flex align-items-center"><span class="nav-link-icon"><span
                                    class="fas fa-unlock-alt"></span></span><span class="nav-link-text">
                                Authentication</span>
                        </div>
                    </a>
                    <ul class="nav collapse" id="authentication" data-parent="#navbarVerticalCollapse">
                        <li class="nav-item"><a class="nav-link dropdown-indicator" href="#authentication-basic"
                                data-toggle="collapse" role="button" aria-expanded="false"
                                aria-controls="authentication-basic">Basic</a>
                            <ul class="nav collapse" id="authentication-basic" data-parent="#authentication">
                                <li class="nav-item"><a class="nav-link"
                                        href="authentication/basic/login.html">Login</a>
                                </li>
                                <li class="nav-item"><a class="nav-link"
                                        href="authentication/basic/logout.html">Logout</a>
                                </li>
                                <li class="nav-item"><a class="nav-link"
                                        href="authentication/basic/register.html">Register</a>
                                </li>
                                <li class="nav-item"><a class="nav-link"
                                        href="authentication/basic/forgot-password.html">Forgot password</a>
                                </li>
                                <li class="nav-item"><a class="nav-link"
                                        href="authentication/basic/reset-password.html">Reset password</a>
                                </li>
                                <li class="nav-item"><a class="nav-link"
                                        href="authentication/basic/confirm-mail.html">Confirm mail</a>
                                </li>
                                <li class="nav-item"><a class="nav-link"
                                        href="authentication/basic/lock-screen.html">Lock screen</a>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item"><a class="nav-link dropdown-indicator" href="#authentication-card"
                                data-toggle="collapse" role="button" aria-expanded="false"
                                aria-controls="authentication-card">Card</a>
                            <ul class="nav collapse" id="authentication-card" data-parent="#authentication">
                                <li class="nav-item"><a class="nav-link" href="authentication/card/login.html">Login</a>
                                </li>
                                <li class="nav-item"><a class="nav-link"
                                        href="authentication/card/logout.html">Logout</a>
                                </li>
                                <li class="nav-item"><a class="nav-link"
                                        href="authentication/card/register.html">Register</a>
                                </li>
                                <li class="nav-item"><a class="nav-link"
                                        href="authentication/card/forgot-password.html">Forgot password</a>
                                </li>
                                <li class="nav-item"><a class="nav-link"
                                        href="authentication/card/reset-password.html">Reset password</a>
                                </li>
                                <li class="nav-item"><a class="nav-link"
                                        href="authentication/card/confirm-mail.html">Confirm mail</a>
                                </li>
                                <li class="nav-item"><a class="nav-link"
                                        href="authentication/card/lock-screen.html">Lock screen</a>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item"><a class="nav-link dropdown-indicator" href="#authentication-split"
                                data-toggle="collapse" role="button" aria-expanded="false"
                                aria-controls="authentication-split">Split</a>
                            <ul class="nav collapse" id="authentication-split" data-parent="#authentication">
                                <li class="nav-item"><a class="nav-link"
                                        href="authentication/split/login.html">Login</a>
                                </li>
                                <li class="nav-item"><a class="nav-link"
                                        href="authentication/split/logout.html">Logout</a>
                                </li>
                                <li class="nav-item"><a class="nav-link"
                                        href="authentication/split/register.html">Register</a>
                                </li>
                                <li class="nav-item"><a class="nav-link"
                                        href="authentication/split/forgot-password.html">Forgot password</a>
                                </li>
                                <li class="nav-item"><a class="nav-link"
                                        href="authentication/split/reset-password.html">Reset password</a>
                                </li>
                                <li class="nav-item"><a class="nav-link"
                                        href="authentication/split/confirm-mail.html">Confirm mail</a>
                                </li>
                                <li class="nav-item"><a class="nav-link"
                                        href="authentication/split/lock-screen.html">Lock screen</a>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="authentication/wizard.html">Wizard</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="#!" data-toggle="modal"
                                data-target="#authentication-modal">In modal</a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item"><a class="nav-link dropdown-indicator" href="#e-commerce" data-toggle="collapse"
                        role="button" aria-expanded="false" aria-controls="e-commerce">
                        <div class="d-flex align-items-center"><span class="nav-link-icon"><span
                                    class="fas fa-cart-plus"></span></span><span class="nav-link-text"> E
                                commerce</span>
                        </div>
                    </a>
                    <ul class="nav collapse" id="e-commerce" data-parent="#navbarVerticalCollapse">
                        <li class="nav-item"><a class="nav-link" href="e-commerce/checkout.html">Checkout</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="e-commerce/customer-details.html">Customer
                                details</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="e-commerce/customers.html">Customers</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="e-commerce/order-details.html">Order details</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="e-commerce/orders.html">Orders</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="e-commerce/product-details.html">Product
                                details</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="e-commerce/product-grid.html">Product grid</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="e-commerce/product-list.html">Product list</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="e-commerce/shopping-cart.html">Shopping cart</a>
                        </li>
                    </ul>
                </li>
-->
            </ul>
            <div class="navbar-vertical-divider">
                <hr class="navbar-vertical-hr my-2" />
            </div>
            <div class="navbar-vertical-divider">
                ${state.online?  'en ligne' : 'hors ligne' }
            </div>
            <!--
            <ul class="navbar-nav flex-column">
                <li class="nav-item"><a class="nav-link" href="widgets.html">
                        <div class="d-flex align-items-center"><span class="nav-link-icon"><span
                                    class="fas fa-poll"></span></span><span class="nav-link-text"> Widgets</span>
                        </div>
                    </a>
                </li>
                <li class="nav-item"><a class="nav-link dropdown-indicator" href="#components" data-toggle="collapse"
                        role="button" aria-expanded="false" aria-controls="components">
                        <div class="d-flex align-items-center"><span class="nav-link-icon"><span
                                    class="fas fa-puzzle-piece"></span></span><span class="nav-link-text">
                                Components</span>
                        </div>
                    </a>
                    <ul class="nav collapse" id="components" data-parent="#navbarVerticalCollapse">
                        <li class="nav-item"><a class="nav-link" href="components/accordion.html">Accordion</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/alerts.html">Alerts</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/avatar.html">Avatar</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/background.html">Background</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/badges.html">Badges</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/breadcrumb.html">Breadcrumb</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/bulk-select.html">Bulk select</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/buttons.html">Buttons</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/cards.html">Cards</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/carousel.html">Carousel</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/close-button.html">Close button</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/collapse.html">Collapse</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/cookie-notice.html">Cookie notice</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/dropdowns.html">Dropdowns</a>
                        </li>
                        <li class="nav-item"><a class="nav-link nav-link-disable"
                                href="components/fancyscroll.html">Fancyscroll</a>
                        </li>
                        <li class="nav-item"><a class="nav-link nav-link-disable"
                                href="components/fancytab.html">Fancytab</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/figures.html">Figures</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/hoverbox.html">Hoverbox</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/images.html">Images</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/list-group.html">List group</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/modals.html">Modals</a>
                        </li>
                        <li class="nav-item"><a class="nav-link dropdown-indicator" href="#components-navbar"
                                data-toggle="collapse" role="button" aria-expanded="false"
                                aria-controls="components-navbar">Navbar</a>
                            <ul class="nav collapse" id="components-navbar" data-parent="#components">
                                <li class="nav-item"><a class="nav-link"
                                        href="components/navbar/default.html">Default</a>
                                </li>
                                <li class="nav-item"><a class="nav-link"
                                        href="components/navbar/vertical.html">Vertical</a>
                                </li>
                                <li class="nav-item"><a class="nav-link"
                                        href="components/navbar/darken-on-scroll.html">Darken on scroll</a>
                                </li>
                                <li class="nav-item"><a class="nav-link" href="components/navbar/top.html">Top</a>
                                </li>
                                <li class="nav-item"><a class="nav-link" href="components/navbar/combo.html">Combo</a>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/navs.html">Navs</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/page-headers.html">Page headers</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/pagination.html">Pagination</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/popovers.html">Popovers</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/progress.html">Progress</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/scrollspy.html">Scrollspy</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/search.html">Search</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/sidepanel.html">Sidepanel</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/spinners.html">Spinners</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/tables.html">Tables</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/tabs.html">Tabs</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/toasts.html">Toasts</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/tooltips.html">Tooltips</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="components/typography.html">Typography</a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item"><a class="nav-link dropdown-indicator" href="#forms" data-toggle="collapse"
                        role="button" aria-expanded="false" aria-controls="forms">
                        <div class="d-flex align-items-center"><span class="nav-link-icon"><span
                                    class="fas fa-align-left"></span></span><span class="nav-link-text"> Forms</span>
                        </div>
                    </a>
                    <ul class="nav collapse" id="forms" data-parent="#navbarVerticalCollapse">
                        <li class="nav-item"><a class="nav-link" href="forms/checks.html">Checks</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="forms/file.html">File</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="forms/form-control.html">Form control</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="forms/input-group.html">Input group</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="forms/layout.html">Layout</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="forms/overview.html">Overview</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="forms/range.html">Range</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="forms/select.html">Select</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="forms/validation.html">Validation</a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item"><a class="nav-link dropdown-indicator" href="#utilities" data-toggle="collapse"
                        role="button" aria-expanded="false" aria-controls="utilities">
                        <div class="d-flex align-items-center"><span class="nav-link-icon"><span
                                    class="fas fa-fire"></span></span><span class="nav-link-text"> Utilities</span>
                        </div>
                    </a>
                    <ul class="nav collapse" id="utilities" data-parent="#navbarVerticalCollapse">
                        <li class="nav-item"><a class="nav-link" href="utilities/borders.html">Borders</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="utilities/clearfix.html">Clearfix</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="utilities/colored-links.html">Colored links</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="utilities/colors.html">Colors</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="utilities/display.html">Display</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="utilities/embed.html">Embed</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="utilities/flex.html">Flex</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="utilities/float.html">Float</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="utilities/grid.html">Grid</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="utilities/position.html">Position</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="utilities/sizing.html">Sizing</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="utilities/spacing.html">Spacing</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="utilities/stretched-link.html">Stretched link</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="utilities/text-truncation.html">Text
                                truncation</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="utilities/vertical-align.html">Vertical align</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="utilities/visibility.html">Visibility</a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item"><a class="nav-link dropdown-indicator" href="#plugins" data-toggle="collapse"
                        role="button" aria-expanded="false" aria-controls="plugins">
                        <div class="d-flex align-items-center"><span class="nav-link-icon"><span
                                    class="fas fa-plug"></span></span><span class="nav-link-text"> Plugins</span>
                        </div>
                    </a>
                    <ul class="nav collapse" id="plugins" data-parent="#navbarVerticalCollapse">
                        <li class="nav-item"><a class="nav-link" href="plugins/anchor.html">Anchor</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="plugins/countup.html">Countup</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="plugins/choices.html">Choices</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="plugins/date-picker.html">Date picker</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="plugins/draggable.html">Draggable</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="plugins/dropzone.html">Dropzone</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="plugins/echarts.html">Echarts</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="plugins/emoji-button.html">Emoji button</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="plugins/fontawesome.html">Fontawesome</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="plugins/fullcalendar.html">Fullcalendar</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="plugins/glightbox.html">Glightbox</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="plugins/progressbar.html">Progressbar</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="plugins/inline-player.html">Inline player</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="plugins/list.html">List</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="plugins/lottie.html">Lottie</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="plugins/typed-text.html">Typed text</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="plugins/tinymce.html">Tinymce</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="plugins/swiper.html">Swiper</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="plugins/rater.html">Rater</a>
                        </li>
                        <li class="nav-item"><a class="nav-link dropdown-indicator" href="#plugins-map"
                                data-toggle="collapse" role="button" aria-expanded="false"
                                aria-controls="plugins-map">Map</a>
                            <ul class="nav collapse" id="plugins-map" data-parent="#plugins">
                                <li class="nav-item"><a class="nav-link" href="plugins/map/leaflet-map.html">Leaflet
                                        map</a>
                                </li>
                                <li class="nav-item"><a class="nav-link" href="plugins/map/google-map.html">Google
                                        map</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
            <div class="navbar-vertical-divider">
                <hr class="navbar-vertical-hr my-2" />
            </div>
            <ul class="navbar-nav flex-column">
                <li class="nav-item"><a class="nav-link dropdown-indicator" href="#documentation" data-toggle="collapse"
                        role="button" aria-expanded="false" aria-controls="documentation">
                        <div class="d-flex align-items-center"><span class="nav-link-icon"><span
                                    class="fas fa-book"></span></span><span class="nav-link-text"> Documentation</span>
                        </div>
                    </a>
                    <ul class="nav collapse" id="documentation" data-parent="#navbarVerticalCollapse">
                        <li class="nav-item"><a class="nav-link" href="documentation/getting-started.html">Getting
                                started</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="documentation/file-structure.html">File
                                structure</a>
                        </li>
                        <li class="nav-item"><a class="nav-link"
                                href="documentation/customization.html">Customization</a>
                        </li>
                        <li class="nav-item"><a class="nav-link nav-link-disable"
                                href="documentation/dark-mode.html">Dark mode</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="documentation/fluid-layout.html">Fluid layout</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="documentation/gulp.html">Gulp</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="documentation/RTL.html">RTL</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="documentation/plugins.html">Plugins</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="documentation/design-file.html">Design file</a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item"><a class="nav-link" href="changelog.html">
                        <div class="d-flex align-items-center"><span class="nav-link-icon"><span
                                    class="fas fa-code-branch"></span></span><span class="nav-link-text">
                                Changelog</span>
                        </div>
                    </a>
                </li>
            </ul>
            <div class="settings">
                <div class="navbar-vertical-divider">
                    <hr class="navbar-vertical-hr my-3" />
                </div><a class="btn btn-sm btn-block btn-purchase"
                    href="https://themes.getbootstrap.com/product/falcon-admin-dashboard-webapp-template/"
                    target="_blank">Purchase</a>
            </div>
-->
        </div>
    </div>
</nav>`;
}

export function Nav2({showNavbar,setShowNavbar}:any) {

    const [show, setShow] = useState('');
    const [syncing, setSyncing] = useState(false);
    const [offline, setOffline] = useState(false);


    const [profileOpen, setProfileOpen] = useState(false);

    const [state, dispatch] = store.useSession();

    useEffect(() => {
        const handler = () => {
            setProfileOpen(false);
            setShow('');
            setShowNavbar(false);
        };
        document.addEventListener('click', handler);
        return () => {
            document.removeEventListener('click', handler);
        };
    },[])


    // state.setSyncing = setSyncing;
    // state.setOffline = setOffline;

    function canShowSearch(){
        return window.location.pathname !== '/patients' && !window.location.pathname.startsWith('/drugs');
    }


    return html`<nav class="navbar navbar-light navbar-glass navbar-top navbar-expand">

    <button onclick=${(ev:any)=> {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        setShowNavbar(!showNavbar);
     }} class="btn navbar-toggler-humburger-icon navbar-toggler mr-1 mr-sm-3" type="button" data-toggle="collapse"
        data-target="#navbarVerticalCollapse" aria-controls="navbarVerticalCollapse" aria-expanded="false"
        aria-label="Toggle Navigation"><span class="navbar-toggle-icon"><span
                class="toggle-line"></span></span></button>
    <a class="navbar-brand mr-1 mr-sm-3" href="/">
        <div class="d-flex align-items-center"><span class="font-sans-serif">NEO</span>
        </div>
    </a>

    <ul class="navbar-nav align-items-center d-none d-lg-block">
        <li class="nav-item">
            <div class="search-box" data-list='{"valueNames":["title"]}'>
                <form class="position-relative" data-toggle="search" data-display="static">
                    <input class="form-control search-input fuzzy-search" type="search" placeholder="Search..."
                        aria-label="Search" value=${state.search} oninput=${(ev: any) => {
                    dispatch({ type: 'search', data: ev.target.value });
                    setShow(ev.target.value.length >= 2 && canShowSearch() ? 'show' : '')
                    }
   } onfocus=${(ev: any) => setShow(ev.target.value.length >= 2 && canShowSearch() ? 'show' :
                    '')} onclick=${(ev:Event)=> {
                        ev.preventDefault();
                        ev.stopImmediatePropagation();
                        ev.stopPropagation();
                    }} />
                    <span class="fas fa-search search-box-icon"></span>
                </form>

                <button class="btn-close position-absolute right-0 top-50 translate-middle shadow-none p-1 mr-1 fs--2"
                    type="button" data-dismiss="search"></button>

                <div class="dropdown-menu border font-base left-0 mt-2 py-0 overflow-hidden w-100 ${show}">
                    <div class="scrollbar list py-3" style="max-height: 24rem;">
                        <!--
                        <h6 class="dropdown-header font-weight-medium text-uppercase px-card fs--2 pt-0 pb-2">Recently
                            Browsed</h6><a class="dropdown-item fs--1 px-card py-1 hover-primary"
                            href="pages/events.html">
                            <div class="d-flex align-items-center">
                                <span class="fas fa-circle mr-2 text-300 fs--2"></span>

                                <div class="font-weight-normal title">Pages <span
                                        class="fas fa-chevron-right mx-1 text-500 fs--2"
                                        data-fa-transform="shrink-2"></span> Events</div>
                            </div>
                        </a>
                        <a class="dropdown-item fs--1 px-card py-1 hover-primary" href="e-commerce/customers.html">
                            <div class="d-flex align-items-center">
                                <span class="fas fa-circle mr-2 text-300 fs--2"></span>

                                <div class="font-weight-normal title">E-commerce <span
                                        class="fas fa-chevron-right mx-1 text-500 fs--2"
                                        data-fa-transform="shrink-2"></span> Customers</div>
                            </div>
                        </a>

                        <hr class="bg-200" />
                        <h6 class="dropdown-header font-weight-medium text-uppercase px-card fs--2 pt-0 pb-2">Suggested
                            Filter</h6><a class="dropdown-item px-card py-1 fs-0" href="e-commerce/customers.html">
                            <div class="d-flex align-items-center"><span
                                    class="badge font-weight-medium text-decoration-none mr-2 badge-soft-warning">customers:</span>
                                <div class="flex-1 fs--1 title">All customers list</div>
                            </div>
                        </a>
                        <a class="dropdown-item px-card py-1 fs-0" href="pages/events.html">
                            <div class="d-flex align-items-center"><span
                                    class="badge font-weight-medium text-decoration-none mr-2 badge-soft-success">events:</span>
                                <div class="flex-1 fs--1 title">Latest events in current month</div>
                            </div>
                        </a>
                        <a class="dropdown-item px-card py-1 fs-0" href="e-commerce/product-grid.html">
                            <div class="d-flex align-items-center"><span
                                    class="badge font-weight-medium text-decoration-none mr-2 badge-soft-info">products:</span>
                                <div class="flex-1 fs--1 title">Most popular products</div>
                            </div>
                        </a>

                        <hr class="bg-200" />
                        <h6 class="dropdown-header font-weight-medium text-uppercase px-card fs--2 pt-0 pb-2">Files</h6>
                        <a class="dropdown-item px-card py-2" href="#!">
                            <div class="d-flex align-items-center">
                                <div class="file-thumbnail mr-2"><img class="border h-100 w-100 fit-cover rounded-lg"
                                        src="assets/img/products/3-thumb.png" alt="" /></div>
                                <div class="flex-1">
                                    <h6 class="mb-0 title">iPhone</h6>
                                    <p class="fs--2 mb-0"><span class="font-weight-semi-bold">Antony</span><span
                                            class="font-weight-medium text-600 ml-2">27 Sep at 10:30 AM</span></p>
                                </div>
                            </div>
                        </a>
                        <a class="dropdown-item px-card py-2" href="#!">
                            <div class="d-flex align-items-center">
                                <div class="file-thumbnail mr-2"><img class="img-fluid" src="assets/img/icons/zip.png"
                                        alt="" /></div>
                                <div class="flex-1">
                                    <h6 class="mb-0 title">Falcon v1.8.2</h6>
                                    <p class="fs--2 mb-0"><span class="font-weight-semi-bold">John</span><span
                                            class="font-weight-medium text-600 ml-2">30 Sep at 12:30 PM</span></p>
                                </div>
                            </div>
                        </a>

                        <hr class="bg-200" />-->
                        

                        ${searchView(state,dispatch)}


                    </div>
                </div>
            </div>
        </li>
    </ul>
    <ul class="navbar-nav navbar-nav-icons ml-auto flex-row align-items-center">
        <!--
        <li class="nav-item"><a class="nav-link settings-popover" href="#settings-modal" data-toggle="modal"><span
                    class="ripple"></span><span class="fa-spin position-absolute all-0 d-flex flex-center"><span
                        class="icon-spin position-absolute all-0 d-flex flex-center">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.7369 12.3941L19.1989 12.1065C18.4459 11.7041 18.0843 10.8487 18.0843 9.99495C18.0843 9.14118 18.4459 8.28582 19.1989 7.88336L19.7369 7.59581C19.9474 7.47484 20.0316 7.23291 19.9474 7.03131C19.4842 5.57973 18.6843 4.28943 17.6738 3.20075C17.5053 3.03946 17.2527 2.99914 17.0422 3.12011L16.393 3.46714C15.6883 3.84379 14.8377 3.74529 14.1476 3.3427C14.0988 3.31422 14.0496 3.28621 14.0002 3.25868C13.2568 2.84453 12.7055 2.10629 12.7055 1.25525V0.70081C12.7055 0.499202 12.5371 0.297594 12.2845 0.257272C10.7266 -0.105622 9.16879 -0.0653007 7.69516 0.257272C7.44254 0.297594 7.31623 0.499202 7.31623 0.70081V1.23474C7.31623 2.09575 6.74999 2.8362 5.99824 3.25599C5.95774 3.27861 5.91747 3.30159 5.87744 3.32493C5.15643 3.74527 4.26453 3.85902 3.53534 3.45302L2.93743 3.12011C2.72691 2.99914 2.47429 3.03946 2.30587 3.20075C1.29538 4.28943 0.495411 5.57973 0.0322686 7.03131C-0.051939 7.23291 0.0322686 7.47484 0.242788 7.59581L0.784376 7.8853C1.54166 8.29007 1.92694 9.13627 1.92694 9.99495C1.92694 10.8536 1.54166 11.6998 0.784375 12.1046L0.242788 12.3941C0.0322686 12.515 -0.051939 12.757 0.0322686 12.9586C0.495411 14.4102 1.29538 15.7005 2.30587 16.7891C2.47429 16.9504 2.72691 16.9907 2.93743 16.8698L3.58669 16.5227C4.29133 16.1461 5.14131 16.2457 5.8331 16.6455C5.88713 16.6767 5.94159 16.7074 5.99648 16.7375C6.75162 17.1511 7.31623 17.8941 7.31623 18.7552V19.2891C7.31623 19.4425 7.41373 19.5959 7.55309 19.696C7.64066 19.7589 7.74815 19.7843 7.85406 19.8046C9.35884 20.0925 10.8609 20.0456 12.2845 19.7729C12.5371 19.6923 12.7055 19.4907 12.7055 19.2891V18.7346C12.7055 17.8836 13.2568 17.1454 14.0002 16.7312C14.0496 16.7037 14.0988 16.6757 14.1476 16.6472C14.8377 16.2446 15.6883 16.1461 16.393 16.5227L17.0422 16.8698C17.2527 16.9907 17.5053 16.9504 17.6738 16.7891C18.7264 15.7005 19.4842 14.4102 19.9895 12.9586C20.0316 12.757 19.9474 12.515 19.7369 12.3941ZM10.0109 13.2005C8.1162 13.2005 6.64257 11.7893 6.64257 9.97478C6.64257 8.20063 8.1162 6.74905 10.0109 6.74905C11.8634 6.74905 13.3792 8.20063 13.3792 9.97478C13.3792 11.7893 11.8634 13.2005 10.0109 13.2005Z"
                                fill="#2A7BE4"></path>
                        </svg></span></span></a></li>
        <li class="nav-item">
            <a class="nav-link px-0 notification-indicator notification-indicator-warning notification-indicator-fill icon-indicator"
                href="e-commerce/shopping-cart.html"><span class="fas fa-shopping-cart fs-4"
                    data-fa-transform="shrink-7"></span><span class="notification-indicator-number">1</span></a>

        </li>
        <li class="nav-item dropdown">
            <a class="nav-link notification-indicator notification-indicator-primary px-0 icon-indicator"
                id="navbarDropdownNotification" href="#" role="button" data-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false"><span class="fas fa-bell fs-4" data-fa-transform="shrink-6"></span></a>
            <div class="dropdown-menu dropdown-menu-right dropdown-menu-card"
                aria-labelledby="navbarDropdownNotification">
                <div class="card card-notification shadow-none">
                    <div class="card-header">
                        <div class="row justify-content-between align-items-center">
                            <div class="col-auto">
                                <h6 class="card-header-title mb-0">Notifications</h6>
                            </div>
                            <div class="col-auto"><a class="card-link font-weight-normal" href="#">Mark all as read</a>
                            </div>
                        </div>
                    </div>
                    <div class="list-group list-group-flush font-weight-normal fs--1">
                        <div class="list-group-title border-bottom">NEW</div>
                        <div class="list-group-item">
                            <a class="notification notification-flush notification-unread" href="#!">
                                <div class="notification-avatar">
                                    <div class="avatar avatar-2xl mr-3">
                                        <img class="rounded-circle" src="assets/img/team/1-thumb.png" alt="" />

                                    </div>
                                </div>
                                <div class="notification-body">
                                    <p class="mb-1"><strong>Emma Watson</strong> replied to your comment : "Hello world
                                        😍"</p>
                                    <span class="notification-time"><span class="mr-1" role="img"
                                            aria-label="Emoji">💬</span>Just now</span>

                                </div>
                            </a>

                        </div>
                        <div class="list-group-item">
                            <a class="notification notification-flush notification-unread" href="#!">
                                <div class="notification-avatar">
                                    <div class="avatar avatar-2xl mr-3">
                                        <div class="avatar-name rounded-circle"><span>AB</span></div>
                                    </div>
                                </div>
                                <div class="notification-body">
                                    <p class="mb-1"><strong>Albert Brooks</strong> reacted to <strong>Mia
                                            Khalifa's</strong> status</p>
                                    <span class="notification-time"><span
                                            class="mr-1 fab fa-gratipay text-danger"></span>9hr</span>

                                </div>
                            </a>

                        </div>
                        <div class="list-group-title border-bottom">EARLIER</div>
                        <div class="list-group-item">
                            <a class="notification notification-flush" href="#!">
                                <div class="notification-avatar">
                                    <div class="avatar avatar-2xl mr-3">
                                        <img class="rounded-circle" src="assets/img/icons/weather-sm.jpg" alt="" />

                                    </div>
                                </div>
                                <div class="notification-body">
                                    <p class="mb-1">The forecast today shows a low of 20&#8451; in California. See
                                        today's weather.</p>
                                    <span class="notification-time"><span class="mr-1" role="img"
                                            aria-label="Emoji">🌤</span>1d</span>

                                </div>
                            </a>

                        </div>
                    </div>
                    <div class="card-footer text-center border-top"><a class="card-link d-block"
                            href="pages/notifications.html">View all</a></div>
                </div>
            </div>
        </li>
        
        <li class="nav-item dropdown">
            <a class="nav-link pr-0" role="button" style="font-size: 18px;padding-right: 4px !important;" onclick=${(ev: any)=> {

                fetch('/api/v1/health')
                .then(res=>res.json())
                .then(_=>{
                        caches.keys().then(function (cacheNames) {
                            return Promise.all(
                                cacheNames.filter(it=>it!=='/').map(function (cacheName) {
                                        return caches.delete(cacheName);
                                })
                            );
                        }).then(()=>location.reload(true));

                    }).catch(_=> alert(`Vous êtes hors ligne!`));
        }}>
                Mettre à jour
            </a>
        </li>
        -->
        <li class="nav-item dropdown install-btn" style=${ (window.matchMedia('(display-mode: standalone)').matches ||
            (window.navigator as any).standalone === true) ? 'display:none' : '' }>
            <a class="nav-link pr-0" role="button" style="font-size: 18px;padding-right: 4px !important;" onclick=${(ev: any)=> {
                showInstallInstructions();
        }}>
                Installer
            </a>
        </li>

        <li class="nav-item dropdown"><a class="nav-link pr-0" role="button" onclick=${(ev: any)=> {
            ev.preventDefault();
            ev.stopImmediatePropagation();
             setProfileOpen(!profileOpen);
        }}>
                <div class="avatar avatar-xl">
                    <img class="rounded-circle" src="assets/img/team/avatar.png" alt="" />

                </div>
            </a>
            <${ProfileDropdown} show=${profileOpen} />

        </li>
    </ul>
</nav>
<div class="modal fade" 
             id="install-info"
             tabindex="-1" 
             role="dialog"> 
            <div class="modal-dialog" 
                 role="document"> 
                <div class="modal-content" style="width:516px"> 
                    <div class="modal-header"> 
                        <!-- w-100 class so that header 
                div covers 100% width of parent div -->
                        <h5 class="modal-title w-100" 
                            id="exampleModalLabel"> 
                          Comment installer 
                      </h5> 
                    </div> 
  
                    <!--Modal body with image-->
                    <div class="modal-body"> 
                        <img src="/assets/img/install.png" /> 
                    </div> 

                </div> 
            </div> 
        </div> 
`;
}

export function ProfileDropdown({ show }: { show: boolean }) {
    return html`<div class="dropdown-menu dropdown-menu-right py-0 ${show ? 'show' : ''}">
    <div class="bg-white rounded-lg py-2">
   <!--
    <a class="dropdown-item font-weight-bold text-warning" href="#!"><span class="fas fa-crown mr-1"></span><span>Go
                Pro</span></a>

        <div class="dropdown-divider"></div>
        <a class="dropdown-item" href="#!">Set status</a>
        <a class="dropdown-item" href="pages/profile.html">Profile &amp; account</a>
        <a class="dropdown-item" href="#!">Feedback</a>

        <div class="dropdown-divider"></div>
        <a class="dropdown-item" href="/settings">Settings</a>
-->
        <a class="dropdown-item" href="/logout">Logout</a>
    </div>
</div>`;
}

function None(){
    route('/patients');
}

export function Page() {
    const session = store.useSession();
    return html`<${Router}>
    <${PatientsOverview} a="sd" path="/patients" />
    <${UnpaidPatientsOverview} a="sd" path="/stats/patients-unpaid" />
    <${AddPatient} path="/patients-add" />
    <${PatientDetails} path="/patients/:id" />
    <${UpdatePatient} path="/patients/:id/edit" />
    <${AddPrescription} path="/patients/:id/prescribe" />
    <${Calendar} path="/calendar" />
    <${Kanban} path="/waiting" />
    <${FileDetails} path="/files/:id" />
    <${Stats} path="/stats/revenue" />
    <${DrugsOverview} path="/drugs" />
    <${PrescriptionView} path="/prescriptions/:id" />
    <${DrugView} path="/drugs/:id" />
    <${PurchaseOrdersOverview} path="/inventory/purchase-orders" />
    <${AddPurchaseOrder} path="/inventory/purchase-orders/new" />
    <${PurchaseOrderDetails} path="/inventory/purchase-orders/:id" />

    <${None} default />
</${Router}>`;
}

export function Main() {
console.log('check')
    const [session, dispatch] = store.useSession();

    if (!session.token) {
        return route('/login');
    }


    const [showNavbar, setShowNavbar] = useState(false);
    const [progress, setProgress] = useState(0);

    const [int,setInt] = useState(null as any);

    if(!session.preloaded) {

        useEffect(()=>{
            let now = Date.now();
            setInt(setInterval(()=> {
                const progress = ( Math.sqrt((Date.now() - now)/2));
                setProgress(progress);
                if(progress>100) {
                    clearInterval(int);
                }
            }, 30));
           return ()=> clearInterval(int);
        },[])
        
        
        return html`<div style="width:100%;text-align:center;padding-top:100px">
            <h4>chargement de données...</h4>
            <h6>ça peut durer une minute, veuillez patientez svp</h6>
            <br/>
            <div class="progress" style="width:300px;margin:auto">
            <div class="progress-bar progress-bar-striped progress-bar-animated" id="progress-toggle" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: ${progress}%"></div>
            </div>
        </div>`;
    }else {

        if(int) {
            clearInterval(int);
        }

    return html`<main class="main" id="top">
    <div class="container-fluid">
        <${Nav1} ...${{showNavbar, setShowNavbar}}  />
        <div class="content">
            <${Nav2} ...${{showNavbar, setShowNavbar}} />
            <${Page} />
            <footer>
                <div class="row g-0 justify-content-between fs--1 mt-4 mb-3">

                </div>
            </footer>
        </div>
        <div class="modal fade modal-fixed-right modal-theme overflow-hidden" id="settings-modal" tabindex="-1"
            role="dialog" aria-labelledby="settings-modal-label" aria-hidden="true"
            data-options='{"autoShow":true,"autoShowDelay":3000,"showOnce":true}'>
            <div class="modal-dialog modal-dialog-vertical" role="document">
                <div class="modal-content border-0 vh-100 scrollbar">
                    <div class="modal-header modal-header-settings">
                        <div class="z-index-1 py-1">
                            <h5 class="text-white" id="settings-modal-label"> <span
                                    class="fas fa-palette mr-2 fs-0"></span>Settings</h5>
                            <p class="mb-0 fs--1 text-white opacity-75"> Set your own customized style</p>
                        </div>
                        <button class="btn-close btn-close-white z-index-1 mt-0" type="button" data-dismiss="modal"
                            aria-label="Close"></button>
                    </div>
                    <div class="modal-body px-card">
                        <div class="d-flex justify-content-between">
                            <div class="d-flex align-items-start"><img class="mr-2"
                                    src="assets/img/icons/left-arrow-from-left.svg" width="20" alt="" />
                                <div class="flex-1">
                                    <h5 class="fs-0">RTL Mode</h5>
                                    <p class="fs--1 mb-0">Switch your language direction </p>
                                </div>
                            </div>
                            <div class="form-check form-switch">
                                <input class="form-check-input ml-0" id="mode-rtl" type="checkbox"
                                    data-home-url="index.html" data-page-url="documentation/RTL.html" />
                            </div>
                        </div>
                        <hr />
                        <div class="d-flex justify-content-between">
                            <div class="d-flex align-items-start"><img class="mr-2" src="assets/img/icons/arrows-h.svg"
                                    width="20" alt="" />
                                <div class="flex-1">
                                    <h5 class="fs-0">Fluid Layout</h5>
                                    <p class="fs--1 mb-0">Toggle container layout system </p>
                                </div>
                            </div>
                            <div class="form-check form-switch">
                                <input class="form-check-input ml-0" id="mode-fluid" type="checkbox"
                                    data-home-url="index.html" data-page-url="documentation/fluid-layout.html" />
                            </div>
                        </div>
                        <hr />
                        <div class="d-flex align-items-start"><img class="mr-2" src="assets/img/icons/paragraph.svg"
                                width="20" alt="" />
                            <div class="flex-1">
                                <h5 class="fs-0 d-flex align-items-center">Navigation Position </h5>
                                <p class="fs--1 mb-2">Select a suitable navigation system for your web application </p>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" id="option-navbar-vertical" type="radio"
                                        name="navbar" value="vertical" checked="checked"
                                        data-page-url="components/navbar/vertical.html" />
                                    <label class="form-check-label" for="option-navbar-vertical">Vertical</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" id="option-navbar-top" type="radio" name="navbar"
                                        value="top" data-page-url="components/navbar/top.html" />
                                    <label class="form-check-label" for="option-navbar-top">Top</label>
                                </div>
                                <div class="form-check form-check-inline mr-0">
                                    <input class="form-check-input" id="option-navbar-combo" type="radio" name="navbar"
                                        value="combo" data-page-url="components/navbar/combo.html" />
                                    <label class="form-check-label" for="option-navbar-combo">Combo</label>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <h5 class="fs-0 d-flex align-items-center">Vertical Navbar Style</h5>
                        <p class="fs--1">Switch between styles for your vertical navbar </p>
                        <div class="btn-group btn-block btn-group-navbar-style">
                            <div class="row gx-2">
                                <div class="col-6">
                                    <input class="btn-check" id="navbar-style-transparent" type="radio"
                                        name="navbarStyle" checked="checked" data-page-url="index.html"
                                        value="transparent" />
                                    <label class="btn btn-block btn-navbar-style fs--1" for="navbar-style-transparent">
                                        <img class="img-fluid img-prototype" src="assets/img/generic/default.png"
                                            alt="" /><span class="label-text"> Transparent</span></label>
                                </div>
                                <div class="col-6">
                                    <input class="btn-check" id="navbar-style-inverted" type="radio" name="navbarStyle"
                                        data-page-url="demo/navbar-vertical-inverted.html" value="inverted" />
                                    <label class="btn btn-block btn-navbar-style fs--1" for="navbar-style-inverted">
                                        <img class="img-fluid img-prototype" src="assets/img/generic/inverted.png"
                                            alt="" /><span class="label-text"> Inverted</span></label>
                                </div>
                                <div class="col-6">
                                    <input class="btn-check" id="navbar-style-card" type="radio" name="navbarStyle"
                                        data-page-url="demo/navbar-vertical-card.html" value="card" />
                                    <label class="btn btn-block btn-navbar-style fs--1" for="navbar-style-card"> <img
                                            class="img-fluid img-prototype" src="assets/img/generic/card.png"
                                            alt="" /><span class="label-text"> Card</span></label>
                                </div>
                                <div class="col-6">
                                    <input class="btn-check" id="navbar-style-vibrant" type="radio" name="navbarStyle"
                                        data-page-url="demo/navbar-vertical-vibrant.html" value="vibrant" />
                                    <label class="btn btn-block btn-navbar-style fs--1" for="navbar-style-vibrant"> <img
                                            class="img-fluid img-prototype" src="assets/img/generic/vibrant.png"
                                            alt="" /><span class="label-text"> Vibrant</span></label>
                                </div>
                            </div>
                        </div>
                        <div class="text-center mt-5"><img class="mb-4" src="assets/img/illustrations/settings.png"
                                alt="" width="120" />
                            <h5>Like What You See?</h5>
                            <p class="fs--1">Get Falcon now and create beautiful dashboards with hundreds of widgets.
                            </p><a class="btn btn-primary"
                                href="https://themes.getbootstrap.com/product/falcon-admin-dashboard-webapp-template/"
                                target="_blank">Purchase</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="authentication-modal" tabindex="-1" role="dialog"
            aria-labelledby="authentication-modal-label" aria-hidden="true">
            <div class="modal-dialog mt-6" role="document">
                <div class="modal-content border-0">
                    <div class="modal-header px-5 text-white position-relative modal-shape-header">
                        <div class="position-relative z-index-1">
                            <h4 class="mb-0 text-white" id="authentication-modal-label">Register</h4>
                            <p class="fs--1 mb-0">Please create your free Falcon account</p>
                        </div>
                        <button class="btn-close btn-close-white position-absolute top-0 right-0 mt-2 mr-2"
                            data-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body py-4 px-5">
                        <form>
                            <div class="mb-3">
                                <label class="form-label" for="modal-auth-name">Name</label>
                                <input class="form-control" type="text" id="modal-auth-name" />
                            </div>
                            <div class="mb-3">
                                <label class="form-label" for="modal-auth-email">Email address</label>
                                <input class="form-control" type="email" id="modal-auth-email" />
                            </div>
                            <div class="row gx-3">
                                <div class="mb-3 col-sm-6">
                                    <label class="form-label" for="modal-auth-password">Password</label>
                                    <input class="form-control" type="password" id="modal-auth-password" />
                                </div>
                                <div class="mb-3 col-sm-6">
                                    <label class="form-label" for="modal-auth-confirm-password">Confirm Password</label>
                                    <input class="form-control" type="password" id="modal-auth-confirm-password" />
                                </div>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="modal-auth-register-checkbox" />
                                <label class="form-label" for="modal-auth-register-checkbox">I accept the <a
                                        href="#!">terms </a>and <a href="#!">privacy policy</a></label>
                            </div>
                            <div class="mb-3">
                                <button class="btn btn-primary btn-block mt-3" type="submit"
                                    name="submit">Register</button>
                            </div>
                        </form>
                        <div class="position-relative mt-5">
                            <hr class="bg-300" />
                            <div
                                class="position-absolute top-50 left-50 translate-middle px-3 bg-white font-sans-serif fs--1 text-500 text-nowrap">
                                or register with</div>
                        </div>
                        <div class="row g-2 mt-2">
                            <div class="col-sm-6"><a class="btn btn-outline-google-plus btn-sm btn-block" href="#"><span
                                        class="fab fa-google-plus-g mr-2" data-fa-transform="grow-8"></span> google</a>
                            </div>
                            <div class="col-sm-6"><a class="btn btn-outline-facebook btn-sm btn-block" href="#"><span
                                        class="fab fa-facebook-square mr-2" data-fa-transform="grow-8"></span>
                                    facebook</a></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>
`;
    }
}



function searchView(state:store.SessionContext,dispatch:any){

    const path = window.location.pathname;

    if(path.indexOf('/purchase-orders/') !== -1 || path.indexOf('/prescribe') !== -1) {

        return html`<h6 class="dropdown-header font-weight-medium text-uppercase px-card fs--2 pt-0 pb-2">Drugs</h6>
        ${store.searchVisibleDrugs(state.drugs, state.search).slice(0, 5).map(drug => html`<div
            style="display:flex"><a class="dropdown-item px-card py-2"
            onclick=${()=> dispatch({type: 'quick', data:{drug}})}>
                <div class="d-flex align-items-center">
                    <div class="avatar avatar-l statuss-onlinee mr-2">
                        <img class="rounded-circle" src="assets/img/team/2.jpg" alt="" />
    
                    </div>
                    <div class="flex-1">
                        <h6 class="mb-0 title">${drug.fullname || drug.name}</h6>
                        <p class="fs--2 mb-0">${drug._id}</p>
                    </div>
                </div>
            </a><a href="/drugs/${drug._id}" class="dropdown-item px-card py-2" style="width:50px">
                <div class="d-flex align-items-center" style="padding-top:8px">
                    <${FontAwesomeIcon} icon=${['fa', 'eye' ]} />
                </div>
    
            </a>
        </div>`)}`;


    }else {

    return html`<h6 class="dropdown-header font-weight-medium text-uppercase px-card fs--2 pt-0 pb-2">Patients
    </h6>
    ${store.searchPatients(state.patients, state.search).slice(0, 5).map(patient => html`<div
        style="display:flex"><a class="dropdown-item px-card py-2"
        onclick=${()=> dispatch({
type: 'quick-patient', data:
patient
})}
        
        >
            <div class="d-flex align-items-center">
                <div class="avatar avatar-l statuss-onlinee mr-2">
                    <img class="rounded-circle" src="assets/img/team/2.jpg" alt="" />

                </div>
                <div class="flex-1">
                    <h6 class="mb-0 title">${patient.firstName} ${patient.lastName}</h6>
                    <p class="fs--2 mb-0">${patient.birthdate}</p>
                </div>
            </div>
        </a><a href="/patients/${patient._id}" class="dropdown-item px-card py-2" style="width:50px">
                        <div class="d-flex align-items-center" style="padding-top:8px">
                <${FontAwesomeIcon} icon=${['fa', 'eye' ]} />
            </div>

        </a>
    </div>`)}`;

}

}